'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _FormattedRelative = require('I18n/components/FormattedRelative');

var _FormattedRelative2 = _interopRequireDefault(_FormattedRelative);

var _commonMessageFormatGetters = require('conversations-schema/common-message-format/operators/commonMessageFormatGetters');

var _responderGetters = require('conversations-schema/responders/operators/responderGetters');

var _threadGetters = require('conversations-schema/thread/operators/threadGetters');

var _ChatHeadingConfigPropType = require('ui-addon-conversations/chat-heading-config/prop-types/ChatHeadingConfigPropType');

var _ChatHeadingConfigPropType2 = _interopRequireDefault(_ChatHeadingConfigPropType);

var _hasUserAndTeamResponders = require('conversations-schema/chat-heading-config/operators/hasUserAndTeamResponders');

var _ChatHead = require('conversations-visitor-experience-components/visitor-widget/ChatHead');

var _ChatHead2 = _interopRequireDefault(_ChatHead);

var _AutomatedMessageAvatars = require('ui-addon-conversations/components/AutomatedMessageAvatars');

var _AutomatedMessageAvatars2 = _interopRequireDefault(_AutomatedMessageAvatars);

var _CustomChatHeading = require('conversations-visitor-experience-components/visitor-widget/CustomChatHeading');

var _CustomChatHeading2 = _interopRequireDefault(_CustomChatHeading);

var _ThreadPreviewText = require('./ThreadPreviewText');

var _ThreadPreviewText2 = _interopRequireDefault(_ThreadPreviewText);

var _RecordPropType = require('conversations-prop-types/prop-types/RecordPropType');

var _RecordPropType2 = _interopRequireDefault(_RecordPropType);

var _ThreadListItemWrapper = require('./ThreadListItemWrapper');

var _ThreadListItemWrapper2 = _interopRequireDefault(_ThreadListItemWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ThreadListItem = _react2.default.createClass({
  displayName: 'ThreadListItem',

  propTypes: {
    assignedResponder: (0, _RecordPropType2.default)('Responder'),
    chatHeadingConfig: _ChatHeadingConfigPropType2.default.isRequired,
    coloring: (0, _RecordPropType2.default)('ColoringRecord'),
    onClick: _react.PropTypes.func.isRequired,
    sendFromResponders: _react.PropTypes.instanceOf(_immutable.List).isRequired,
    thread: (0, _RecordPropType2.default)('Conversation').isRequired
  },

  getFirstNameOrAgent: function getFirstNameOrAgent(responder) {
    return (0, _responderGetters.getFirstName)(responder) || _I18n2.default.text('conversations-visitor-ui.default.agent');
  },
  getFallbackResponder: function getFallbackResponder() {
    var sendFromResponders = this.props.sendFromResponders;


    return sendFromResponders && sendFromResponders.get(0);
  },
  getAssignedResponder: function getAssignedResponder() {
    var _props = this.props,
        assignedResponder = _props.assignedResponder,
        thread = _props.thread;


    return assignedResponder || (0, _threadGetters.getResponder)(thread);
  },
  canRenderMultipleAvatars: function canRenderMultipleAvatars() {
    var _props2 = this.props,
        sendFromResponders = _props2.sendFromResponders,
        chatHeadingConfig = _props2.chatHeadingConfig;


    return (0, _hasUserAndTeamResponders.hasUserAndTeamResponders)(chatHeadingConfig) && sendFromResponders && sendFromResponders.size > 1;
  },
  hasCustomChatHeading: function hasCustomChatHeading() {
    return !!this.props.chatHeadingConfig.customChatName;
  },
  renderTimestamp: function renderTimestamp() {
    var latestMessage = (0, _threadGetters.getLatestMessage)(this.props.thread);
    var timestamp = (0, _commonMessageFormatGetters.getTimestamp)(latestMessage);

    return _react2.default.createElement(_FormattedRelative2.default, { value: timestamp });
  },
  renderText: function renderText() {
    var latestMessage = (0, _threadGetters.getLatestMessage)(this.props.thread);
    var unseenCount = (0, _threadGetters.getUnseenCount)(this.props.thread);

    return _react2.default.createElement(_ThreadPreviewText2.default, {
      className: 'm-y-2',
      latestMessage: latestMessage,
      unseenCount: unseenCount
    });
  },
  renderAssignedResponder: function renderAssignedResponder() {
    var _props3 = this.props,
        coloring = _props3.coloring,
        thread = _props3.thread;


    var assignedResponder = this.getAssignedResponder();

    return _react2.default.createElement(_ThreadListItemWrapper2.default, {
      onClick: this.props.onClick,
      coloring: coloring,
      nameText: this.getFirstNameOrAgent(assignedResponder),
      renderAvatar: function renderAvatar() {
        return _react2.default.createElement(_ChatHead2.default, {
          avatar: (0, _responderGetters.getAvatar)(assignedResponder),
          isBot: (0, _responderGetters.getIsBot)(assignedResponder),
          online: (0, _responderGetters.getIsOnline)(assignedResponder),
          className: 'visitor-chat-head',
          isVisitorWidget: true
        });
      },
      renderText: this.renderText,
      renderTimestamp: this.renderTimestamp,
      unseenCount: (0, _threadGetters.getUnseenCount)(thread)
    });
  },
  renderFallback: function renderFallback() {
    var _props4 = this.props,
        coloring = _props4.coloring,
        thread = _props4.thread;


    var fallbackResponder = this.getFallbackResponder();

    return _react2.default.createElement(_ThreadListItemWrapper2.default, {
      onClick: this.props.onClick,
      coloring: coloring,
      nameText: this.getFirstNameOrAgent(fallbackResponder),
      renderAvatar: function renderAvatar() {
        return _react2.default.createElement(_ChatHead2.default, {
          avatar: (0, _responderGetters.getAvatar)(fallbackResponder),
          isBot: (0, _responderGetters.getIsBot)(fallbackResponder),
          online: (0, _responderGetters.getIsOnline)(fallbackResponder),
          className: 'visitor-chat-head',
          isVisitorWidget: true
        });
      },
      renderText: this.renderText,
      renderTimestamp: this.renderTimestamp,
      unseenCount: (0, _threadGetters.getUnseenCount)(thread)
    });
  },
  renderCustom: function renderCustom() {
    var _this = this;

    var _props5 = this.props,
        coloring = _props5.coloring,
        thread = _props5.thread,
        chatHeadingConfig = _props5.chatHeadingConfig;


    return _react2.default.createElement(_ThreadListItemWrapper2.default, {
      onClick: this.props.onClick,
      coloring: coloring,
      nameText: chatHeadingConfig.customChatName,
      renderAvatar: function renderAvatar() {
        return _react2.default.createElement(_CustomChatHeading2.default, {
          chatHeadingConfig: _this.props.chatHeadingConfig,
          size: 'md'
        });
      },
      renderText: this.renderText,
      renderTimestamp: this.renderTimestamp,
      unseenCount: (0, _threadGetters.getUnseenCount)(thread)
    });
  },
  renderMultipleAvatars: function renderMultipleAvatars() {
    var _this2 = this;

    var _props6 = this.props,
        coloring = _props6.coloring,
        thread = _props6.thread,
        sendFromResponders = _props6.sendFromResponders;


    return _react2.default.createElement(_ThreadListItemWrapper2.default, {
      onClick: this.props.onClick,
      coloring: coloring,
      nameText: sendFromResponders.map(_responderGetters.getFirstName).join(', '),
      renderAvatar: function renderAvatar() {
        return _react2.default.createElement(_AutomatedMessageAvatars2.default, {
          size: 'large',
          responders: _this2.props.sendFromResponders
        });
      },
      renderText: this.renderText,
      renderTimestamp: this.renderTimestamp,
      unseenCount: (0, _threadGetters.getUnseenCount)(thread)
    });
  },
  render: function render() {
    switch (true) {
      case !!this.getAssignedResponder():
        return this.renderAssignedResponder();

      case this.hasCustomChatHeading():
        return this.renderCustom();

      case this.canRenderMultipleAvatars():
        return this.renderMultipleAvatars();

      default:
        return this.renderFallback();
    }
  }
});

exports.default = ThreadListItem;
module.exports = exports['default'];